<template>
	<div class="post-type">
		<ul>
			<li>
                <router-link to="post/trending" class="navitem router-link-active">
                    Trending
                </router-link>
			</li>
			<li>
                <router-link to="post/latest" class="navitem">
                    Latest
                </router-link>
			</li>
			<li>
                <router-link to="post/personal" class="navitem">
                    Personal
                </router-link>
			</li>
		</ul>

	</div>
</template>



<script>


export default {
  name: "post-type",

	data(){
		return{

		}
	},

	methods:{


	}

}

</script>


<style type="text/css">
	
	.post-type ul {
	    margin: 0;
	    padding: 0;
	    list-style: none;
	}
	.post-type li {
	    display: inline-block;
	    margin-right: 30px;
	}

	.post-type li:last-child {
	    margin-right: 0px;
	}

	.post-type li .navitem {
		color: #214163;
	    font-family: Lato;
	    font-size: 24px;
	    font-weight: 700;
	    line-height: 29px;
	    letter-spacing: 0.8571429px;
	    opacity: 0.4;
	    padding: 14px 0px;
	}
	.post-type li .navitem.router-link-active {
	    opacity:1;
	    position: relative;
	}
	.post-type li .navitem.router-link-active:after {
		position: absolute;
	    content: "";
	    width: 6px;
	    height: 6px;
	    background: #214163;
	    border-radius: 100%;
	    bottom: -4px;
	    left: 45%;
	}
</style>